import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, Grid, TextField, Button } from '@mui/material';
import { createLevel } from '../services/api';

const AddLevel = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    level_name: '',
    level: '',
    type: '',
    designation: '',
    offshore_per_hr: '',
    onsite_per_hr: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleReset = () => {
    setFormData({
      level_name: '',
      level: '',
      type: '',
      designation: '',
      offshore_per_hr: '',
      onsite_per_hr: '',
    });
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!formData.level_name) {
      setError('Level Name is required');
      return;
    }
    try {
      await createLevel(formData);
      setSuccess('Level created successfully');
      handleReset();
    } catch (err) {
      setError(err.message || 'Failed to create level');
    }
  };

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto', p: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Add New Level</Typography>
        <Button variant="contained" color="success" onClick={() => navigate('/levels/list')}>Level Details</Button>
      </Box>
      <Paper sx={{ p: 3 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Level Name"
                name="level_name"
                value={formData.level_name}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Level"
                name="level"
                value={formData.level}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Type"
                name="type"
                value={formData.type}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Designation"
                name="designation"
                value={formData.designation}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Offshore Per Hr"
                name="offshore_per_hr"
                value={formData.offshore_per_hr}
                onChange={handleChange}
                type="number"
                inputProps={{ min: 0 }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Onsite Per Hr"
                name="onsite_per_hr"
                value={formData.onsite_per_hr}
                onChange={handleChange}
                type="number"
                inputProps={{ min: 0 }}
              />
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2 }}>
              <Button type="submit" variant="contained" color="primary">Save</Button>
              <Button type="button" variant="contained" color="error" onClick={handleReset}>Reset</Button>
            </Grid>
            {error && (
              <Grid item xs={12}>
                <Typography color="error">{error}</Typography>
              </Grid>
            )}
            {success && (
              <Grid item xs={12}>
                <Typography color="success.main">{success}</Typography>
              </Grid>
            )}
          </Grid>
        </form>
      </Paper>
    </Box>
  );
};

export default AddLevel; 